import {FC, useMemo} from "react";
import {CreateEmployeeModalProps} from "./types";
import {Modal, Spin} from "antd";
import EmployeeForm from "./employee-form/EmployeeForm";
import {EMPLOYEE_TYPES} from "../../../enums/employeeTypes";

const CreateEmployeeModal: FC<CreateEmployeeModalProps> = (props) => {
  const {employeeController} = props
  const {selectedEmployee, isCreateModalOpen, toggleCreateModalOpen, isLoading, form} = employeeController

  const title = useMemo(() => {
    return selectedEmployee ? `Редагування: ${selectedEmployee.fullName}` : `Додати нового працівника`
  }, [selectedEmployee])

  const okButtonHandler = () => {
    form.submit()
  }

  return <Modal width={1000} centered title={title} open={isCreateModalOpen} onOk={okButtonHandler}
                onCancel={toggleCreateModalOpen} cancelButtonProps={{title: "Закрити"}}
                okText="Зберегти">
    <Spin spinning={isLoading}>
      <EmployeeForm employeeType={EMPLOYEE_TYPES.ADMINISTRATION} employeeController={employeeController}/>
    </Spin>
  </Modal>
}


export default CreateEmployeeModal